var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useMemo } from 'react';
import { useTransition } from '@react-spring/web';
import cx from 'classnames';
import { Description } from '../description/description';
import { CloseIcon } from '../close-icon/close-icon';
import { Container, Operation, Message, Content } from './styles';
import { createPortal } from 'react-dom';
let id = 0;
let add;
const cancelMap = new Map();
export const info = (msg) => {
    add(msg);
    return () => {
        var _a;
        (_a = cancelMap.get(msg.key)) === null || _a === void 0 ? void 0 : _a();
    };
};
export const cancel = (key) => {
    var _a;
    (_a = cancelMap.get(key)) === null || _a === void 0 ? void 0 : _a();
};
export function Notification(_a) {
    var { config = { tension: 125, friction: 20, precision: 0.1 }, 
    // inf will never close
    timeout = Infinity } = _a, props = __rest(_a, ["config", "timeout"]);
    const refMap = useMemo(() => new WeakMap(), []);
    const [items, setItems] = useState([]);
    add = (msg) => {
        id += 1;
        setItems((state) => {
            if (props.limit) {
                return [...state, Object.assign(Object.assign({}, msg), { key: msg.key || id })].slice(0, props.limit);
            }
            return [...state, Object.assign(Object.assign({}, msg), { key: msg.key || id })];
        });
    };
    const transitions = useTransition(items, {
        from: { opacity: 0, height: 0, life: '100%' },
        keys: (item) => item.key,
        enter: (item) => (next, cancel) => __awaiter(this, void 0, void 0, function* () {
            cancelMap.set(item.key, cancel);
            yield next({ opacity: 1, height: refMap.get(item).offsetHeight });
            yield next({ life: '00%' });
        }),
        leave: [{ opacity: 0 }, { height: 0 }],
        onRest: (_result, _ctrl, item) => {
            setItems((state) => state.filter((i) => {
                return i.key !== item.key;
            }));
        },
        config: (_item, _index, phase) => (key) => phase === 'enter' && key === 'life' ? { duration: timeout } : config,
    });
    if (typeof window === 'undefined') {
        return null;
    }
    return createPortal(React.createElement(Container, { className: cx('notification', props.className), "data-role": "notification" }, transitions((_a, item) => {
        var style = __rest(_a, []);
        return (React.createElement(Message, { className: "notification-message", "data-role": "notification-message", style: style },
            React.createElement(Content, { className: "notification-message-content", "data-role": "notification-message-content", ref: (ref) => ref && refMap.set(item, ref) },
                React.createElement(Description, { title: item.title, content: item.description }),
                item.btn && React.createElement(Operation, null, item.btn)),
            React.createElement(CloseIcon, { position: "absolute", top: 8, right: 8, onClick: (e) => {
                    e.stopPropagation();
                    if (cancelMap.has(item.key)) {
                        cancelMap.get(item.key)();
                    }
                } })));
    })), document.body);
}
